import { Stack } from "@mui/material";
import { AddToTargetedListBtn } from "./AddToTargetedListBtn";
import { RemoveRecommendedBtn } from "./RemoveRecommendedBtn";
import { setRemovedIds } from "../../features/companySlice";
import { useAppDispatch } from "../../hooks";

type Props = {
  ids: string[];
  isDemo?: boolean;
};

export const RecommendedAccountActionBlock = ({ ids, isDemo }: Props) => {
  const dispatch = useAppDispatch();

  const removeHandler = () => {
    dispatch(setRemovedIds(ids));
  };

  return (
    <Stack flexDirection={"row"} gap={"8px"}>
      <AddToTargetedListBtn
        ids={ids}
        successHandler={removeHandler}
        fullWidth={true}
        isDemo={isDemo}
      />
      <RemoveRecommendedBtn
        ids={ids}
        successHandler={removeHandler}
        isDemo={isDemo}
      />
    </Stack>
  );
};
